<template>
  <table class="sticky">
    <thead>
      <tr>
        <slot name="head">
          <th>Default</th>
        </slot>
      </tr>
    </thead>
    <tbody>
      <slot name="body"></slot>
    </tbody>
  </table>
  <div v-if="data.length == 0 && isLoading" class="progress-bar">
    <div class="progress-bar-value"></div>
  </div>
  <div v-if="data.length == 0" class="table_loader">
    <h5 v-if="!isLoading && data.length == 0" class="clr-red-froly">No Record Found</h5>
    <!--  <div  class="db-spinner db-spinner-table"></div> -->
  </div>
</template>

<script>
export default {
  name: "DpTable",
  props: {
    data: { type: Array, default: () => [] },
    isLoading: { type: Boolean, default: false }
  }
};
</script>
